import React from "react";
import { Fill, Root, Track, ValueLabel } from "./ProgressBar.styles";
import type { ProgressBarProps } from "./ProgressBar.types";

/** Horizontal percentage bar with an optional value beside it — e.g. field completeness. */
export const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  valueLabel,
  ariaLabelledBy,
  ariaLabel,
  size = "md",
  testId,
  className,
}) => (
  <Root data-testid={testId} className={className}>
    <Track
      $size={size}
      data-size={size}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={value}
      aria-valuetext={valueLabel}
      aria-labelledby={ariaLabelledBy}
      aria-label={ariaLabel}
    >
      <Fill $value={value} data-testid={testId ? `${testId}-fill` : undefined} />
    </Track>
    {valueLabel ? <ValueLabel aria-hidden="true">{valueLabel}</ValueLabel> : null}
  </Root>
);

export default ProgressBar;
